import { Box } from '@mui/material';
import { bool, func, node, object, string } from 'prop-types';
import React from 'react';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '44px',
    paddingRight: 3,
    boxShadow: 'inset 0 -1px 0 0 #dde2eb',
  },
  heading: {
    height: '22px',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSize: '15px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: '-0.5px',
    lineHeight: 1.47,
  },
  placeholder: {
    marginLeft: 'auto',
  },
  active: {
    cursor: 'pointer',
  },
  statusText: {
    marginLeft: 'auto',
    fontSize: '14px',
    color: 'text.secondary',
    marginRight: 2,
  },
  enabledStatusText: {
    color: 'tertiary.dark',
  },
};

const Item = ({
  headline,
  checkbox = null,
  onClick = null,
  statusText = null,
  statusEnabled = false,
  children = null,
  sx = {},
}) => (
  <Box onClick={onClick} sx={[styles.root, !onClick || styles.active, sx]}>
    <Box sx={styles.heading}>{headline}</Box>
    {statusText && (
      <Box sx={[styles.statusText, !statusEnabled || styles.enabledStatusText]}>{statusText}</Box>
    )}
    {checkbox && <Box sx={styles.placeholder}>{checkbox}</Box>}
    {children}
  </Box>
);

Item.propTypes = {
  headline: node.isRequired,
  checkbox: node,
  onClick: func,
  statusText: string,
  statusEnabled: bool,
  children: node,
  sx: object,
};

export default Item;
